import { useContext, useEffect } from "react";
import Toggle from "../../CommonComponents/Toggle/Toggle";
import { saveKeyValue } from "../CommonWorkers";
import { AppContext } from "../../Context/AppContext";
function ThemeToggle() {
	const { theme, setTheme } = useContext(AppContext);
	const color = theme.color.toLowerCase();
	const handleTheme = () => {
		const targetThemeColor = color === "light" ? "dark" : "light";
		setTheme((prev) => {
			const theme = { ...prev };
			theme.color = targetThemeColor;
			return theme;
		});
		console.log("targetThemeColor => ", targetThemeColor);
		saveKeyValue("color", targetThemeColor);
	};
	useEffect(() => {
		// saveKeyValue("color", theme.color);
	}, [theme]);
	return (
		<div
			className={`theme-color-button ${color === "light" ? "" : "day"}`}
			onClick={handleTheme}
			style={{ fontSize: "16px" }}
			title={color === "light" ? "тёмный" : "светлый"}
		>
			{color === "light" ? "тёмный" : "светлый"}
			{/* <svg
				className={theme.color === "light" ? "moon" : "sun"}
				viewBox='0 0 1440 320'
				version='1.1'
				xmlns='http://www.w3.org/2000/svg'
			>
				<circle cx='80' cy='80' r='80' />
			</svg>
			<svg
				className={theme.color === "light" ? "dark-hill" : "sunny-hill"}
				xmlns='http://www.w3.org/2000/svg'
				viewBox='0 0 1440 320'
			>
				<path
					fillOpacity='1'
					d='M0,128L48,133.3C96,139,192,149,288,133.3C384,117,480,75,576,69.3C672,64,768,96,864,106.7C960,117,1056,107,1152,128C1248,149,1344,203,1392,229.3L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'
				></path>
			</svg> */}
		</div>
		// <Toggle
		// 	leftText={"Светлая"}
		// 	rigthText={"Темная"}
		// 	func={handleTheme}
		// 	checked={theme.color === "dark"}
		// />
	);
}

export default ThemeToggle;
